export function showroomSlider() {
  const mainEls = document.querySelectorAll(".js-showroom-main");

  mainEls.forEach((mainEl) => {
    const thumbEl = mainEl
      .closest(".c-media-showroom__left")
      ?.querySelector(".js-showroom-thumb");

    if (!thumbEl) return;

    const thumbSwiper = new Swiper(thumbEl, {
      slidesPerView: "auto",
      spaceBetween: 8,
      watchSlidesProgress: true,
    });

    new Swiper(mainEl, {
      thumbs: {
        swiper: thumbSwiper,
      },
    });
  });
}
